
import FavoriteCard from "@/components/FavoriteCard.vue";
export default {
  name: "FavoriteCardSlide",
  components: { FavoriteCard },
  props: ["favorites"],
};
